import React from 'react';
import PropTypes from 'prop-types';

import { FormError, FormGroup, FormLabel } from 'components/Form';

const FormGroupTextarea = ({
  input,
  label,
  placeholder,
  meta: { touched, error },
  ...restProps
}) => (
  <FormGroup touched={touched} error={error}>
    {label && <FormLabel htmlFor={input.name}>{label}</FormLabel>}

    <div className="form__control">
      <textarea
        className="form__field"
        {...input}
        id={input.name}
        placeholder={placeholder}
        rows={6}
        {...restProps}
      />
    </div>

    {touched && error && <FormError>{error}</FormError>}
  </FormGroup>
);

FormGroupTextarea.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
  }),
  placeholder: PropTypes.string,
  label: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

FormGroupTextarea.defaultProps = {
  input: {
    name: '',
    value: '',
  },
  placeholder: '',
  label: '',
  meta: {
    touched: false,
    error: '',
  },
};

export default FormGroupTextarea;
